<template>
	<div class="on_sale_table">
		<div class="table">
			<el-table :height="590" ref="multipleTable" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" label="产品编号">
					<template slot-scope="scope">{{ scope.row.goods_sn }}</template>
				</el-table-column>
				<el-table-column align="center" label="产品信息" width="280">
					<template slot-scope="scope">
						<div class="d-flex flex-row j-sb a-center">
							<img :src="scope.row.goods_thumb" alt=""
								style="width: 3.75rem;height: 3.75rem;margin-right: 0.69rem;border-radius: 0.25rem;">
							<div class="flex-1 d-flex flex-column j-sb a-start"
								style="line-height: 1;height: 3.75rem;text-align: left;">
								<span class="suojin">{{scope.row.goods_name}}</span>
								<span>发布时间{{scope.row.add_time}}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="shop_price" label="价格">
				</el-table-column>
				<el-table-column align="center" label="可选配" >
					<template slot-scope="scope">
						<el-switch v-model="scope.row.is_confirm" @change="switchChange(scope.row)" active-color="#1E69FF" inactive-color="#B5CBF9">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作" width="260">
					<template slot-scope="scope">
						<div id="" class="d-flex a-center">
							<el-button size="mini"
								style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
								round @click="openDetail(scope.$index, scope.row)">查看</el-button>
							<el-button size="mini"
								style="background: #FF9D1F;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
								round @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
							<i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 1.4rem;"
								@click="handleDelete(scope.$index, scope.row)"></i>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div id="" @click="addOptional"
		style="width: 100%;display: flex;align-items: center;justify-content: center;color: #1E69FF;font-size: 1rem;font-weight: 600;background-color: #FFFFFF;padding-top: 10px;padding-bottom: 10px;cursor: pointer;">			
			<img src="../../../assets/itemStore/tianjia.png" style="width: 1rem;height: 1rem;margin-right: 0.5rem;">
			添加选配产品
		</div>
		<footer class="d-flex j-sb a-center">
			<div class="d-flex a-center">
				<div @click="batchOnshelves" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;margin-right: 2rem; text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量上架</div>
				<div @click="batchOffshelves" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;margin-right: 2rem; text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量下架</div>
				<div @click="batchDelshelves" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量删除</div>
			</div>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>
</template>

<script>
	export default {
		props:{
			keyword: {
		        type: String,
		        default: null
		    }
		},
		data(){
			return {
				currentPage: 1, //初始页
				pageSize : 10,
				tableData: [],
				total_records : 0,
				goods_ids : [],
				status : ''
			}
		},
		methods: {
			getOnsalegoods(){
				let param = {
					act : 'goods_optional_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					keyword : this.keyword,
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.goods_list(param).then((res)=>{
					this.tableData = []
					if(res.code == 0){
						res.data.forEach((item) => {
							this.tableData.push({...item,is_confirm:item.status==1?true:false})
						})
						this.total_records = parseInt(res.total_records)
					}
				})
			},
			onoffGoods(){
				let param = {
					act : this.status,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					gop_ids : this.goods_ids.join(',')
				}
				this.$api.goods_list(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getOnsalegoods()
					}else{
						this.$message({
							type : 'error',
							message : res.msg
						})
					}
				})
			},
			delGoods(){
				let param = {
					act : 'del_goods_optional',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					gop_ids : this.goods_ids.join(',')
				}
				this.$api.goods_list(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getOnsalegoods()
					}else{
						this.$message({
							type : 'error',
							message : res.msg
						})
					}
				})
			},
			switchChange(item){
				if(item.is_confirm == false){
					this.status = 'off_goods_optional'
				}else{
					this.status = 'up_goods_optional'
				}
				this.goods_ids.push(item.id)
				this.onoffGoods()
			},
			batchOnshelves(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个公司')
				}else{
					this.status = 'up_goods_optional'
					this.onoffGoods()
				}
			},
			batchOffshelves(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个公司')
				}else{
					this.status = 'off_goods_optional'
					this.onoffGoods()
				}
			},
			batchDelshelves(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个公司')
				}else{
					this.delGoods()
				}
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getOnsalegoods()
			},
			handleSelectionChange(val) {
				let goodsId = []
				val.forEach((item) => {
					goodsId.push(item.id)
				})
				this.goods_ids = goodsId
			},
			handleDelete(index, row){
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.goods_ids.push(row.id)
					this.delGoods()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});  
				})
			},
			openDetail(index,item){
				this.$router.push({
					name: 'show_optional',
					params: {
						id: item.id
					}
				})
			},
			handleEdit(index, item) {
				this.$router.push({
					name: 'edit_optional',
					params: {
						id: item.id
					}
				})
			},
			addOptional(){
				this.$router.push({path:'add_optional'})
			}
		},
		mounted() {
			this.getOnsalegoods()
			this.$nextTick(function() {
				this.$on('childmethods',function(){
					let param = {
						act : 'goods_optional_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						keyword : this.keyword,
						page : this.currentPage,
						size : this.pageSize
					}
					this.$api.goods_list(param).then((res)=>{
						this.tableData = []
						if(res.code == 0){
							res.data.forEach((item) => {
								this.tableData.push({...item,is_confirm:item.status==1?true:false})
							})
							this.total_records = parseInt(res.total_records)
						}
					})
				});
			});
		}
	}
</script>

<style lang="scss" scoped>
	.suojin{
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.on_sale_table{
		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}
		.el-table ::before{
			height: 0;
		}
		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;
			padding: 0 1.25rem;
			box-sizing: border-box;
		}
	}
</style>
